'use strict';

var addLoadedClass = function addLoadedClass() {
  return document.body.classList.add('js-is-loaded');
};

function windowLoaded() {
  document.addEventListener('DOMContentLoaded', addLoadedClass);
  setTimeout(addLoadedClass, 1000);
}

var windowLoaded$1 = windowLoaded();

module.exports = windowLoaded$1;
